import {
    Box,
    BoxProps,
    Button,
    Card,
    CardActions,
    CardContent,
    CardProps,
    Typography,
    useTheme,
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import * as authenticationService from "services/AuthenticationService";
import * as Styles from "pages/employee/beheer/beheer.styles";
import { AxiosError } from "axios";
import * as ApplicationService from "services/application-service";
import { useAuthContext } from "contexts/authContext";

const Beheer = () => {
    const { user, checkAuth } = useAuthContext();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const theme = useTheme();

    const handleClickRequests = () => {
        navigate(`/beheer/aanvragen`);
    };

    const handleClickCertificates = () => {
        navigate(`/beheer/attesten`);
    };

    const handleClickSettings = () => {
        navigate(`/beheer/settings`);
    };

    const handleClickMedewerkers = (): void => {
        navigate(`/beheer/medewerkers`);
    };

    const handleClickExport = () => {
        navigate(`/beheer/export`);
    };

    const handleClickCreateRequest = async () => {
        await ApplicationService.getEmptyApplicationAsync()
            .then((applicationId: string) => {
                navigate(
                    `/aanvraag_veiligheidsverificatie_indienen_andere/${applicationId}`,
                );
            })
            .catch((error: AxiosError<Error>) => {
                // setIsLoading(false);
                // if (error.code === "ERR_NETWORK") {
                // showMessage(t("errors.ERR_NETWORK"), "error", 5000);
                // }
            });
    };

    const handleClickRenew = () => {
        navigate(`/beheer/vernieuwingen`);
    };

    // --- Props ---
    const cardProps: CardProps = {
        sx: Styles.card(theme),
    };

    const wrapperBoxProps: BoxProps = {
        sx: Styles.wrapper(theme),
    };

    return (
        <Box {...wrapperBoxProps}>
            {user &&
                checkAuth(
                    [
                        "BeheerAanvraag",
                        "WeigerenAanvraag",
                        "OpvolgenAanvragen",
                        "External",
                    ],
                    false,
                ) && (
                    <Card {...cardProps}>
                        <CardContent sx={{ flexGrow: 1 }}>
                            <Typography variant="h5" component="div">
                                {t("manage.requestsTitle")}
                            </Typography>
                            <Typography variant="body2">
                                {t("manage.requestsDescription")}
                            </Typography>
                        </CardContent>
                        <CardActions sx={{ justifyContent: "center" }}>
                            <Button
                                size="small"
                                onClick={() => handleClickRequests()}
                            >
                                Open
                            </Button>
                        </CardActions>
                    </Card>
                )}
            {checkAuth(
                [
                    "BeheerAttesten",
                    "ControleAttesten",
                    "IntrekkenAttesten",
                    "OpvolgenAttesten",
                    "External",
                ],
                false,
            ) && (
                <Card {...cardProps}>
                    <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="h5" component="div">
                            {t("manage.certificateTitle")}
                        </Typography>
                        <Typography variant="body2">
                            {t("manage.certificateDescription")}
                        </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                        <Button
                            size="small"
                            onClick={() => handleClickCertificates()}
                        >
                            Open
                        </Button>
                    </CardActions>
                </Card>
            )}
            {checkAuth(["Administrator", "OpvolgenAttesten"], false) && (
                <Card {...cardProps}>
                    <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="h5" component="div">
                            {t("users.overview")}
                        </Typography>
                        <Typography variant="body2">
                            {t("users.description")}
                        </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                        <Button size="small" onClick={handleClickMedewerkers}>
                            Open
                        </Button>
                    </CardActions>
                </Card>
            )}
            {checkAuth(["OpstartenAanvraag", "External"], false) && (
                <Card {...cardProps}>
                    <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="h5" component="div">
                            {t("manage.createRequestTitle")}
                        </Typography>
                        <Typography variant="body2">
                            {t("manage.createRequestDescription")}
                        </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                        <Button size="small" onClick={handleClickCreateRequest}>
                            Open
                        </Button>
                    </CardActions>
                </Card>
            )}
            {checkAuth(["Administrator", "OpvolgenAttesten"], false) && (
                <Card {...cardProps}>
                    <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="h5" component="div">
                            {t("renew.title")}
                        </Typography>
                        <Typography variant="body2">
                            {t("renew.description")}
                        </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                        <Button size="small" onClick={handleClickRenew}>
                            Open
                        </Button>
                    </CardActions>
                </Card>
            )}
            {checkAuth(["Exporteren"]) && (
                <Card {...cardProps}>
                    <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="h5" component="div">
                            {t("manage.exportTitle")}
                        </Typography>
                        <Typography variant="body2">
                            {t("manage.exportDescription")}
                        </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: "center" }}>
                        <Button
                            size="small"
                            onClick={() => handleClickExport()}
                        >
                            Open
                        </Button>
                    </CardActions>
                </Card>
            )}
            {/* {checkAuth(["Administrator", "BeheerOrganisaties"], false) &&
                <Card {...cardProps}>
                    <CardContent>
                        <Typography variant="h5" component="div">
                            {t('company.title')}
                        </Typography>
                        <Typography variant="body2">
                            {t('company.description')}
                        </Typography>
                    </CardContent>
                    <CardActions sx={{ justifyContent: 'center' }}>
                        <Button size="small" onClick={() => navigate(`/beheer/companies`)}>Open</Button>
                    </CardActions>
                </Card>
            } */}
            {checkAuth(["Administrator"]) && (
                <Card {...cardProps}>
                    <CardContent sx={{ flexGrow: 1 }}>
                        <Typography variant="h5" component="div">
                            {t("settings.title")}
                        </Typography>
                        <Typography variant="body2">
                            {t("settings.description")}
                        </Typography>
                    </CardContent>
                    <CardActions
                        sx={{
                            justifyContent: "center",
                        }}
                    >
                        <Button size="small" onClick={handleClickSettings}>
                            Open
                        </Button>
                    </CardActions>
                </Card>
            )}
            {/* <Card {...cardProps}>
                <CardContent>
                    <Typography variant="h5" component="div">
                        Title
                    </Typography>
                    <Typography variant="body2">
                        Description
                    </Typography>
                </CardContent>
                <CardActions sx={{justifyContent: 'center'}}>
                    <Button size="small">Open</Button>
                </CardActions>
            </Card> */}
        </Box>
    );
};

export default Beheer;
